import { CreateElement } from "vue";
import i18n from "@/i18n";
import { DataModules } from "@/store/modules/data";
import { DefaultFilters as UserGroupsFilters } from "@/data/filters/userGroups";
import { DefaultSorters as UserGroupsSorters } from "@/data/sorters/userGroups";
import { IImportMappingSource } from "@/models/imports";
import { IUserGroup } from "@/models/userGroups";

const getUserGroupRoute = (userGroup: IUserGroup) => {
  return {
    name: "adminUserGroup",
    params: {
      userGroupCode: userGroup.code
    }
  };
};

const firstLabel = (
  h: CreateElement,
  userGroup: IUserGroup,
  onClick: Function = () => ({})
) => {
  return h("p", {}, [
    h(
      "u-link",
      {
        props: { to: getUserGroupRoute(userGroup) },
        on: { click: onClick }
      },
      [h("strong", {}, userGroup.name_translated || userGroup.name)]
    )
  ]);
};
const secondLabel = (h: CreateElement, userGroup: IUserGroup) => {
  return h("p", { class: "is-size-8" }, [
    h(
      "span",
      { class: "has-text-grey-light" },
      `${i18n.t("_.id_#", { id: userGroup.id })}`
    )
  ]);
};

export const GroupSource: IImportMappingSource = {
  props: {
    availableFilters: UserGroupsFilters,
    availableSorters: UserGroupsSorters(),
    usedDataModule: DataModules.USER_GROUPS,
    guardFunctionalities: ["list_user_groups"],
    storeParams: querySearch => {
      return querySearch ? { "filter[name|like]": `%${querySearch}%` } : {};
    }
  },
  render: {
    id: (userGroup: IUserGroup) => userGroup.id,
    firstLabel: (h: CreateElement, userGroup: IUserGroup, onClick: Function) =>
      firstLabel(h, userGroup, onClick),
    secondLabel: (h: CreateElement, userGroup: IUserGroup) =>
      secondLabel(h, userGroup),
    media: null
  }
};
